import CallingIcon from 'assets/call-icon-iacst.svg'
import styles from 'components/Registration/Form/signupStyles.module.css'

import { useSelector } from 'react-redux'
const Header = (props) => {
    const examType = useSelector((state) => state.examType.examType)
    return (
        <div className="max-vw-100" style={{ backgroundColor: props.bgColor }}>
            {/* header section */}
            <div className="container pt-lg-1 p-2 p-lg-1 px-3 d-flex justify-content-between align-items-center">
                <a href="https://www.aakash.ac.in/" target="_blank" rel="noreferrer">
                    {/* Header - Customizable Logo */}
                    <img
                        src={props.logo}
                        alt="logo"
                        className={`${props.logoClass}`}
                    />
                </a>
                <div className={`${styles.d_block}`}>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className={`mb-0 d-flex ${styles.callussection}`}>
                            <div>
                                <img src={CallingIcon} alt="calling-icon" />
                            </div>
                            <div>
                                <p
                                    className={`${styles.callheader} font-size-xs font-size-md-sm mb-0`}
                                    style={{ color: props.callcolor }}
                                >
                                    Call us
                                </p>
                                <a
                                    href={`tel:${props.supportNumber}`}
                                    className={`${styles.tollnumber} font-size-md font-size-xs text-decoration-none d-flex fw-700`}
                                    style={{ color: props.numbercolor }}
                                >
                                    <span>{props.supportNumber}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles.m_block}`}>
                    {examType !== 'IAT' && (
                        <div className="d-flex justify-content-between align-items-center">
                            <div className={`mb-0 d-flex ${styles.callussection}`}>
                                <div>
                                    <a
                                        href={`tel:${props.supportNumber}`}
                                        className="font-size-md font-size-xs text-sky-blue-09 text-decoration-none d-flex fw-700"
                                    >
                                        <p
                                            className="font-size-xs font-size-md-sm text-grey mb-0"
                                            style={{ margin: '0px auto' }}
                                        >
                                            <img
                                                src={CallingIcon}
                                                alt="calling-icon"
                                                style={{ width: '32px' }}
                                            />
                                        </p>
                                    </a>
                                    <a
                                        href={`tel:${props.supportNumber}`}
                                        className="font-size-sm text-sky-blue-09 text-decoration-none d-flex fw-700"
                                    >
                                        <span>Call us</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    )}
                    {examType === 'IAT' && (
                        <div className={styles.call_us_text_invictus}>
                            <a
                                href="tel:1800-102-2727"
                                className="font-size-md font-size-xs text-sky-blue-09 text-decoration-none fw-700"
                            >
                                 <p>Call us</p>
                                <img
                                    src="https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/call-icon-mweb.png"
                                    alt="calling-icon"
                                    class="img-fluid"
                                />
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Header
